<template>
    <div class="mt-3 flex flex-col items-center py-3 lg:mx-12">
        <div class="text-xl whitespace-nowrap text-brand lg:mr-6 lg:ml-12">
            <slot name="title"></slot>
        </div>

        <div class="mx-6 text-gray-300 lg:mr-12 lg:ml-6 lg:w-2/3">
            <slot></slot>
        </div>
    </div>
</template>
